<div id="content" class="allcp-form" ng-controller="UberMenuController" ng-init="init()">
    <div ng-include="'modules/customer/uber/menu/item_modal.html'"></div>
    <div ng-include="'modules/customer/uber/menu/menu_modal.html'"></div>
    <div ng-include="'modules/customer/uber/menu/category_modal.html'"></div>
    <div ng-include="'modules/customer/uber/menu/modifier_modal.html'"></div>
    <div ng-include="'modules/customer/partials/top_menu.html'"></div>
    <header class="navbar navbar-fixed-top subnavbar bg-system d-flex align-items-center justify-content-between">
        <h3 class="ml-3">{{ data.store.store_name }}'s Menu</h3>
        <div>
            <a 
                href="#" 
                class="btn hod-button mr10"
                ng-click="saveAllMenu()"
                style="height: 50px;margin-top: 0px;margin-left: 20px;"
            >
                Save Menu
            </a>
            <a 
                href="#" 
                class="btn hod-button mr10"
                ng-style="{'background-color': data.status.status === 'ONLINE' ? 'green' : 'red'}"
                ng-click="changeStoreStatus()"
                style="height: 50px;margin-top: 0px;margin-left: 20px;"
            >
                Store Status : {{ data.status.status }}
            </a>
        </div>

    </header>

    <div class="navbar fixed-panel-footer" ng-if="deleted.length">
        <div class="nav navbar-nav navbar-left">
            <a href="#" ng-click="selectAll(true)" class="btn mr-2 btn-outline">Select All</a>
            <a href="#" ng-click="selectAll(false)" class="btn btn-outline">Unselect</a>
        </div>
        <div class="nav navbar-nav navbar-center">
        </div>
        <div class="nav navbar-nav navbar-right">
            <a href="#" 
                class="btn btn-danger btn-rounded mr-3"
                ng-click="delete('set')" 
                ng-disabled="deleted.length == 0" 
                ng-if="deleted.length > 0"> Delete
            </a>
        </div>
    </div>

    <div class="panel-body">
        <div class="d-flex align-items-center mb-4">
            <a 
                href="#" 
                class="hod-button mr10"
                ng-class="{'btn' : generalType == 'items' }"
                ng-click="setGeneralType('items')"
            >
                Items
            </a>
            
            <a 
                href="#" 
                class="hod-button mr10"
                ng-class="{'btn' : generalType == 'categories' }"
                ng-click="setGeneralType('categories')"
            >
                Categories
            </a>

            <a 
                href="#" 
                class="hod-button mr10"
                ng-class="{'btn' : generalType == 'menus' }"
                ng-click="setGeneralType('menus')"
            >
                Menus
            </a>

            <a 
                href="#" 
                class="hod-button mr10"
                ng-class="{'btn' : generalType == 'modifier_groups' }"
                ng-click="setGeneralType('modifier_groups')"
            >
                Modifier Groups
            </a>
        </div>


        <!-- <div class="d-flex align-items-center mb-4">
            <a 
                href="#" 
                ng-repeat="item in data.menu.categories" 
                class="hod-button mr10"
                ng-class="{'btn' : selectedCategory.id == item.id }"
                ng-click="setCategory(item)"
            >
                {{ item.title.translations.en }}
            </a>
        </div> -->

        <div class="d-flex align-items-center justify-content-between w-100 mt-5 mb-5">
            <div class="form-group floating mb-0">
                <input type="text" class="btn btn-operation text-input form-control" ng-model="filterData.term" placeholder="Search">
                <label>Search</label>
            </div>

            <div class="text-right">
                <a 
                    href="#" 
                    class="btn hod-button"
                    ng-click="addItem()"
                    ng-if="generalType === 'items'"
                >
                    Add Item
                </a>
                <a 
                    href="#" 
                    class="btn hod-button"
                    ng-click="addMenu()"
                    ng-if="generalType === 'menus'"
                >
                    Add Menu
                </a>
                <a 
                    href="#" 
                    class="btn hod-button"
                    ng-click="addCategory()"
                    ng-if="generalType === 'categories'"
                >
                    Add Category
                </a>
                <a 
                    href="#" 
                    class="btn hod-button"
                    ng-click="addModifier()"
                    ng-if="generalType === 'modifier_groups'"
                >
                    Add Modifier Group
                </a>
            </div>
        </div>

        <div ng-if="generalType === 'items'">
            <div class="table-responsive" ng-if="data.menu.items.length > 0">
                <table class="table table-hover tc-checkbox-1 fs13">
                    <thead class="p20">
                        <tr class="bg-light">
                            <th>Name</th>
                            <th>Price</th>
                            <th>Description</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="text-left" ng-repeat="item in data.menu.items | filter: filterData.term | orderBy: 'title.translations.en'">
                            <td class="clickable-row" ng-click="openItem(item)">
                                <div class="avatar-container align-items-center">
                                    <div class="avatar-img" ng-if="item.image_url">
                                        <img ng-src="{{ item.image_url }}" class="img-responsive text-center img-circle" width="36px" height="36px" style="width:36px;  height:36px;" alt="">
                                    </div>
                                    <div class="avatar-detail">
                                        <strong class="text-left" style="font-weight:bold">{{item.title.translations.en}}</strong>
                                    </div>
                                </div>
                            </td>
                            <td class="clickable-row" ng-click="openItem(item)">${{ item.price_info.price / 100 | number:2 }}</td>
                            <td class="clickable-row" ng-click="openItem(item)">{{ item.description.translations.en }}</td>
                            <td>
                                <a href="#" 
                                    class="btn btn-danger btn-rounded mr-3"
                                    ng-click="deleteItem(item)"> Delete
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="table-responsive" ng-if="data.menu.items.length == 0">
                <div class="alert alert-default pastel">
                    <i class="fa fa-info pr10"></i>
                    <strong>
                        Item Not Found!
                    </strong>
                </div>
            </div>
        </div>

        <div ng-if="generalType === 'menus'">
            <div class="table-responsive" ng-if="data.menu.menus.length > 0">
                <table class="table table-hover tc-checkbox-1 fs13">
                    <thead class="p20">
                        <tr class="bg-light">
                            <th class="text-center">Name</th>
                            <th>Categories</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="text-left" ng-repeat="item in data.menu.menus  | filter: filterData.term | orderBy: 'title.translations.en'">
                            <td class="clickable-row" ng-click="openMenu(item)">
                                <strong style="font-weight:bold">{{item.title.translations.en}}</strong>
                            </td>
                            <td class="clickable-row" ng-click="openMenu(item)">
                                <p ng-repeat="cat in getCategories(item.category_ids)">
                                    {{ cat.title.translations.en }}
                                </p>
                            </td>
                            <td>
                                <a href="#" 
                                    class="btn btn-danger btn-rounded mr-3"
                                    ng-click="deleteMenu(item)"> Delete
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="table-responsive" ng-if="data.menu.menus.length == 0">
                <div class="alert alert-default pastel">
                    <i class="fa fa-info pr10"></i>
                    <strong>
                        Menu Not Found!
                    </strong>
                </div>
            </div>

        </div>

        <div ng-if="generalType === 'categories'">
            <div class="table-responsive" ng-if="data.menu.categories.length > 0">
                <table class="table table-hover tc-checkbox-1 fs13">
                    <thead class="p20">
                        <tr class="bg-light">
                            <th class="text-center">Name</th>
                            <th>Menus</th>
                            <th>Items</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="text-left" ng-repeat="item in data.menu.categories  | filter: filterData.term | orderBy: 'title.translations.en'">
                            <td class="text-center clickable-row" ng-click="openCategory(item)">
                                <strong style="font-weight:bold">{{item.title.translations.en}}</strong>
                            </td>
                            <td class="clickable-row" ng-click="openCategory(item)">
                                <p ng-repeat="menu in data.menu.menus" ng-if="menu.category_ids && menu.category_ids.indexOf(item.id) > -1">
                                    {{ menu.title.translations.en }}
                                </p>
                            </td>
                            <td class="clickable-row" ng-click="openCategory(item)">{{ item.entities.length }}</td>
                            <td>
                                <a href="#" 
                                    class="btn btn-danger btn-rounded mr-3"
                                    ng-click="deleteCategory(item)"> Delete
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="table-responsive" ng-if="data.menu.categories.length == 0">
                <div class="alert alert-default pastel">
                    <i class="fa fa-info pr10"></i>
                    <strong>
                        Category Not Found!
                    </strong>
                </div>
            </div>
        </div>

        <div ng-if="generalType === 'modifier_groups'">

            <div class="table-responsive" ng-if="data.menu.modifier_groups.length > 0">
                <table class="table table-hover tc-checkbox-1 fs13">
                    <thead class="p20">
                        <tr class="bg-light">
                            <th class="text-center">Name</th>
                            <th>Options</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="text-left" ng-repeat="item in data.menu.modifier_groups | filter: filterData.term | orderBy: 'title.translations.en'">
                            <td class="clickable-row" ng-click="openModifier(item)">
                                <strong style="font-weight:bold">{{item.title.translations.en}}</strong>
                            </td>
                            <td class="clickable-row" ng-click="openModifier(item)">{{ item.modifier_options.length }}</td>
                            <td>
                                <a href="#" 
                                    class="btn btn-danger btn-rounded mr-3"
                                    ng-click="deleteModifier(item)"> Delete
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="table-responsive" ng-if="data.menu.modifier_groups.length == 0">
                <div class="alert alert-default pastel">
                    <i class="fa fa-info pr10"></i>
                    <strong>
                        Modifier Group Not Found!
                    </strong>
                </div>
            </div>

        </div>
    </div>
    <div ng-include="'modules/company/settings/partials/delete.html'"></div>
</div>